import { MenuItem } from "@kaltura/ds-react-components";
import { useState } from "react";
import { CloneKmeRoomModal, CloneKmeRoomProps } from "./modal/CloneKmeRoomModal";
import { ButtonClickAnalyticsType } from "@kaltura/mediaspace-shared-types";
import { useButtonAnalytics } from "@kaltura/mediaspace-shared-hooks";

export interface CloneKmeRoomMenuItemProps extends CloneKmeRoomProps {
    analyticsData: { pageName: string; buttonType: ButtonClickAnalyticsType };
    buttonLabel: string;
}
/**
 * Clone KME room menu item for media-page title area actions menu
 */
export const CloneKmeRoomMenuItem = (props: CloneKmeRoomMenuItemProps) => {
    const { autoFocus, buttonLabel, analyticsData, ...modalProps } = props;

    const [isOpen, setIsOpen] = useState(false);

    const sendButtonAnalytics = useButtonAnalytics();

    const openModal = () => {
        sendButtonAnalytics(analyticsData.pageName, analyticsData.buttonType);
        setIsOpen(true);
    };

    return (
        <>
            <MenuItem onClick={openModal} autoFocus={autoFocus}>
                {buttonLabel}
            </MenuItem>

            <CloneKmeRoomModal {...modalProps} isOpen={isOpen} />
        </>
    );
};
